import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../../App";
import {
  Row,
  Col,
  Form,
  Button,
  Table,
  FormControl,
  Modal,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import "./WashInventory.css";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import menuLookup from "../../assets/images/menuLookup.svg";
import infoLogo from "../../assets/images/info.png";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import CustomModal from "../modal/CustomModal";
import PreSelectedFleets from "./PreSelectedFleetList";

function WashInventory(props) {
  const navigate = useNavigate();
  const [accountId, setAccountId] = useState("");
  const [selectedAccountOption, setSelectedAccountOption] = useState(null);
  const [selectedAccountWashTypeIds, setSelectedAccountWashTypeIds] =
    useState("");
  const [accountLocationNumber, setAccountLocationNumber] = useState(0);
  const [invoiceFrequency, setInvoiceFrequency] = useState("");
  const [accountName, setAccountName] = useState("");
  const [washtypeId, setWashtypeId] = useState("");
  const [washtypeName, setWashtypeName] = useState("");
  const [accountSummary, setAccountSummary] = useState([]);
  const [selectedAccountWashTypes, setSelectedAccountWashTypes] = useState([]);
  const [washTypes, setWashTypes] = useState([]);
  const [accountWashTypes, setAccountWashTypes] = useState([]);
  const [vehicleNumberList, setVehicleNumberList] = useState([]);
  const [completeVehicleNumberList, setCompleteVehicleNumberList] = useState(
    [],
  );
  const [filteredVehicleNumberList, setFilteredVehicleNumberList] = useState(
    [],
  );
  const [preSelectedFleetNumberList, setPreSelectedFleetNumberList] = useState(
    [],
  );
  const [fleetList, setFleetList] = useState([]);
  const [specialInstructions, setSpecialInstructions] = useState([]);
  const [washtypeQuantity, setWashtypeQuantity] = useState("");
  const [hasUnitOfMeasurement, setHasUnitOfMeasurement] = useState(false);
  const [unitOfMeasurement, setUnitOfMeasurement] = useState("");
  const [filterdWashList, setFilterdWashList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAcknowledgementModal, setShowAcknowledgementModal] =
    useState(false);
  const [showAddFleetsModal, setShowAddFleetsModal] = useState(false);
  const [washInventoryList, setWashInventoryList] = useState([]);
  const [washedFleetList, setWashedFleetList] = useState([]);
  const [instructionAcknowledgements, setInstructionAcknowledgements] =
    useState([]);
  const [instruction, setInstruction] = useState("");

  const handleShowModal = () => {
    setShowAddFleetsModal(true);
  };

  const handleCloseModal = () => {
    setShowAddFleetsModal(false);
  };
  const isWashedVehicle = (
    accountId,
    washTypeId,
    vehicleNumber,
    locationNumber,
  ) => {
    return washedFleetList.some(
      (entry) =>
        entry.accountId === accountId &&
        entry.washTypeId === washTypeId &&
        entry.vehicleNumber === vehicleNumber &&
        entry.locationNumber === locationNumber &&
        isWithinFrequencyThreshold(entry.washFrequency, entry.startTime),
    );
  };
  const UpdateFleetInfo = () => {
    const vehicleNumbers = hasUnitOfMeasurement
      ? ["N/A"]
      : getSelectedFleetFromList().map((item) => item.vehicleNumber);
    const washedFleets = [];
    vehicleNumbers.forEach((fleetNumber) => {
      const washed = isWashedVehicle(
        parseInt(accountId),
        parseInt(washtypeId),
        fleetNumber,
        parseInt(accountLocationNumber),
      );
      if (!washed) {
        const newItem = {
          isSelected: 1,
          isPreSelected: 1,
          name: washtypeName,
          fleetNumber: fleetNumber,
          accountId: parseInt(accountId),
          washtypeId: parseInt(washtypeId),
          quantity: hasUnitOfMeasurement ? washtypeQuantity : 1,
          addedManually: true,
        };
        const exists = preSelectedFleetNumberList.some(
          (item) =>
            item.accountId === newItem.accountId &&
            item.washtypeId === newItem.washtypeId &&
            item.fleetNumber === newItem.fleetNumber,
        );
        if (!exists) {
          setPreSelectedFleetNumberList((prevInput) => [...prevInput, newItem]);
        }
      } else {
        washedFleets.push(fleetNumber);
      }
    });
    if (washedFleets.length > 0) {
      props.setToastMessage(
        `Duplicate wash detected for: ${washedFleets.join(", ")}`,
      );
    }
    handleCloseModal();
    clearWashList();
  };

  const { t } = useTranslation();
  const user = useContext(UserContext);
  const accountOptions = [];

  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    props.setTab("track");
    setAccountSummary(props.accountSummary);
    // setSelectedAccountWashTypes(props.selectedAccountWashTypes);
    setWashTypes(props.washTypes);
    setAccountWashTypes(props.accountWashTypes);
    setCompleteVehicleNumberList(props.vehicleNumberList);
    setWashInventoryList(props.washInventoryList);
    setWashedFleetList(props.washedFleetList);
    setInstructionAcknowledgements(props.instructionAcknowledgements);
  }, [props]);

  function getPreSelectedFleetNumbers() {
    const filteredFleets = vehicleNumberList.filter(
      (item) =>
        item.accountId == parseInt(accountId) &&
        item.locationNumber === parseInt(accountLocationNumber) &&
        item.isPreSelected === 1,
    );
    return filteredFleets;
  }

  useEffect(() => {
    setWashtypeId("");
    if (accountId !== "") {
      accountSummary.every((account) => {
        if (account.accountId === parseInt(accountId)) {
          setInvoiceFrequency(account.invoiceFrequency);
          return false;
        }
        return true;
      });
      filterWashTypeInfo();
      setSpecialInstructions([]);
      const filteredFleets = getPreSelectedFleetNumbers();
      setPreSelectedFleetNumberList(filteredFleets);
    }

    const account = accountSummary.find((item) => item.accountId == accountId);

    const location = account?.locations.find(
      (item) => item.locationNumber == accountLocationNumber,
    );

    const instruction = location?.instruction || account?.instruction;

    setInstruction(instruction || "");

    if (
      instruction?.length > 3 &&
      instructionAcknowledgements.find(
        (item) =>
          item.accountId == accountId &&
          item.locationNumber == accountLocationNumber &&
          item.leadId == user["id"],
      ) === undefined
    ) {
      setShowAcknowledgementModal(true);
    }
  }, [accountId, accountLocationNumber]);

  useEffect(() => {
    const filteredFleets = getPreSelectedFleetNumbers();
    setPreSelectedFleetNumberList(filteredFleets);
  }, [washInventoryList]);

  const isWithinFrequencyThreshold = (frequency, endTime) => {
    const currentDate = new Date();
    const endDate = new Date(endTime);
    currentDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const diffInDays = (currentDate - endDate) / (1000 * 60 * 60 * 24);

    switch (frequency) {
      case "daily":
        return diffInDays < 1;
      case "weekly":
        const currentWeek = moment(currentDate).week();
        const endWeek = moment(endDate).week();
        return currentWeek === endWeek;
      case "biweekly":
        return diffInDays < 14;
      case "30days":
        return diffInDays < 30;
      case "7days":
        return diffInDays < 7;
      case "13days":
        return diffInDays < 13;
      case "monthly":
        const currentMonth = currentDate.getMonth();
        const endMonth = endDate.getMonth();
        return currentMonth === endMonth;
      default:
        return true;
    }
  };

  useEffect(() => {
    const updatedFleetList = completeVehicleNumberList.filter((fleet) => {
      return !washInventoryList.some(
        (washedFleet) =>
          parseInt(washedFleet.accountId) === fleet.accountId &&
          washedFleet.washTypeId === fleet.washtypeId &&
          washedFleet.vehicleNumber === fleet.fleetNumber &&
          washedFleet.locationNumber === fleet.locationNumber &&
          isWithinFrequencyThreshold(fleet.washFrequency, washedFleet.endTime),
      );
    });
    setVehicleNumberList(updatedFleetList);
  }, [completeVehicleNumberList, washInventoryList]);

  useEffect(() => {
    setSelectedOptions([]);
    if (accountId !== "" && washtypeId !== "") {
      filterFleetInfo();
    }
  }, [accountId, washtypeId, accountLocationNumber]);

  useEffect(() => {
    accountSummary.forEach((account) => {
      account.locations.forEach((location) => {
        let option = {
          value:
            account.accountId +
            "#~#" +
            account.name +
            "#~#" +
            location.locationNumber,
          label:
            account.name +
            (account.locations.length > 1 ? " - " + location.name : ""),
          washtypeIds: location.washTypeIds,
        };
        accountOptions.push(option);
      });
    });
  });

  useEffect(() => {
    if (
      accountId &&
      accountSummary.length > 0 &&
      selectedAccountWashTypes.length > 0
    ) {
      const accountItem = accountSummary.find(
        (item) => item.accountId === Number(accountId),
      );
      const accountLocation = accountItem
        ? accountItem.locations.find(
            (item) => item.locationNumber === Number(accountLocationNumber),
          )
        : undefined;

      if (accountLocation && accountLocation.washTypeIds.length > 0) {
        const IDS = accountLocation.washTypeIds;
        const filteredWashes = selectedAccountWashTypes.filter((item) =>
          IDS.includes(item.id),
        );
        setFilterdWashList(filteredWashes);
      } else {
        setFilterdWashList([]);
      }
    }
  }, [
    accountId,
    accountLocationNumber,
    accountSummary,
    selectedAccountWashTypes,
  ]);

  function getSpectialInstructions() {
    let newList = [];
    if (filteredVehicleNumberList.length > 0) {
      newList.push(filteredVehicleNumberList[0]);
      setSpecialInstructions(
        filteredVehicleNumberList[0].instructions !== null ? newList : [],
      );
    } else {
      setSpecialInstructions([]);
    }
  }

  function cleanVehicleNumbers(array) {
    const uniqueNumbers = new Set();
    return array
      .map((vehicle) => {
        if (vehicle && vehicle.label) {
          const cleanLabel = vehicle.label.replace(/\s/g, "");
          if (!uniqueNumbers.has(cleanLabel)) {
            uniqueNumbers.add(cleanLabel);
            return { value: cleanLabel, label: cleanLabel };
          }
        }
        return null;
      })
      .filter(Boolean);
  }

  useEffect(() => {
    getSpectialInstructions();
    setFleetList(cleanVehicleNumbers(getFleetList()));
  }, [filteredVehicleNumberList]);

  function getSelectedFleetFromList() {
    let newList = [];
    if (selectedOptions.length > 0) {
      selectedOptions.map((obj, index) => {
        newList.push({
          vehicleNumber: obj.value.toUpperCase(),
          uuid: uuidv4(),
        });
      });
    } else {
      newList.push("N/A");
    }
    return newList;
  }

  function getFleetList() {
    let newList = [];
    filteredVehicleNumberList.map((obj, index) => {
      newList.push({
        value: obj.fleetNumber.trim().toUpperCase(),
        label: obj.fleetNumber.trim().toUpperCase(),
      });
    });
    return newList;
  }

  function filterFleetInfo() {
    let newList = [];
    vehicleNumberList.forEach((item, index) => {
      if (
        item.accountId === Number(accountId) &&
        item.washtypeId === Number(washtypeId) &&
        item.locationNumber === Number(accountLocationNumber)
      ) {
        newList.push(item);
      }
    });
    setFilteredVehicleNumberList(newList);
  }

  function filterWashTypeInfo() {
    let newList = [];
    if (selectedAccountWashTypeIds) {
      washTypes.forEach((item, index) => {
        if (selectedAccountWashTypeIds.includes(item.id)) {
          newList.push(item);
        }
      });
      setSelectedAccountWashTypes(newList);
    } else {
      setSelectedAccountWashTypes(washTypes);
    }
  }

  function getWashInventoryData() {
    let washInventory = {
      accountId: parseInt(accountId),
      accountName: accountName,
      washTypeId: parseInt(washtypeId),
      washTypeName: washtypeName,
      leadId: user["id"] ? user["id"] : "",
      teamId: user["teamId"] ? user["teamId"] : "",
      vehicles: hasUnitOfMeasurement
        ? [{ vehicleNumber: "N/A", comments: "Added Manually" }]
        : getSelectedFleetFromList().map((item) => ({
            vehicleNumber: item.vehicleNumber,
            comments: "Added Manually",
          })),
      startTime: moment().utc().format(),
      endTime: moment().utc().format(),
      invoiceFrequency: invoiceFrequency,
      uuid: hasUnitOfMeasurement
        ? [uuidv4()]
        : getSelectedFleetFromList().map((item) => item.uuid),
      quantity: washtypeQuantity ? washtypeQuantity : 1,
      locationNumber: parseInt(accountLocationNumber),
    };
    return washInventory;
  }
  function prepareWashInventoryData(washData) {
    let washInventory = {
      accountId: parseInt(accountId),
      accountName: accountName,
      washTypeId: parseInt(washData.washtypeId),
      washTypeName: washData.name,
      leadId: user["id"] ? user["id"] : "",
      teamId: user["teamId"] ? user["teamId"] : "",
      vehicles: [
        {
          vehicleNumber: washData.fleetNumber,
          comments: washData.addedManually ? "Added Manually" : "Pre Selected",
        },
      ],
      startTime: moment().utc().format(),
      endTime: moment().utc().format(),
      uuid: [uuidv4()],
      invoiceFrequency: invoiceFrequency,
      quantity: washData.quantity ? washData.quantity : 1,
      locationNumber: parseInt(accountLocationNumber),
    };
    return washInventory;
  }
  async function getSortedWashlistByWashtype() {
    const output = [];
    const washTypeMap = {};
    let washTypeids = [];

    preSelectedFleetNumberList.forEach((fleet) => {
      const washtypeId = fleet.washtypeId;
      if (fleet.isSelected === 1) {
        if (!washTypeids.includes(washtypeId)) {
          washTypeids.push(washtypeId);
          washTypeMap[washtypeId] = output.length;
          output.push(prepareWashInventoryData(fleet));
        } else {
          output[washTypeMap[washtypeId]].vehicles.push({
            vehicleNumber: fleet.fleetNumber,
            comments: fleet.addedManually ? "Added Manually" : "Pre Selected",
          });
          output[washTypeMap[washtypeId]].uuid.push(uuidv4());
        }
      }
    });
    return output;
  }

  const handleClear = () => {
    setSelectedOptions([]);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleCloseInstructionModal = () => {
    setShowAcknowledgementModal(false);
    clearWashList();
    setShowAcknowledgementModal(false);
    setAccountId("");
    setAccountName("");
    setAccountLocationNumber("");
    setPreSelectedFleetNumberList([]);
    setSelectedAccountWashTypeIds([]);
    setSelectedAccountOption(null);
  };

  const handleAcknowledge = () => {
    let acknowledgementData = {
      leadId: user["id"] ? parseInt(user["id"]) : "",
      accountId: parseInt(accountId),
      locationNumber: parseInt(accountLocationNumber),
      acknowledgementDate: moment().utc().format(),
    };

    props.onAcknowledgement(acknowledgementData);
    setShowAcknowledgementModal(false);
  };

  const handleSelectChange = (newValue, actionMeta) => {
    // Function to check for duplicates
    const hasDuplicates = (options, newOption) => {
      const trimmedNewOption = {
        value: newOption.value.replace(/\s/g, "").toUpperCase(),
        label: newOption.label.replace(/\s/g, "").toUpperCase(),
      };
      return options.some(
        (option) =>
          option.value.replace(/\s/g, "").toUpperCase() ===
            trimmedNewOption.value &&
          option.label.replace(/\s/g, "").toUpperCase() ===
            trimmedNewOption.label,
      );
    };

    // Update the selected options with uppercase values
    if (actionMeta.action === "clear") {
      setShowModal(true);
    } else {
      const updatedOptions = newValue.reduce((acc, option) => {
        if (!hasDuplicates(acc, option)) {
          acc.push({
            ...option,
            value: option.value.trim().toUpperCase(),
            label: option.label.trim().toUpperCase(),
          });
        }
        return acc;
      }, []);

      setSelectedOptions(updatedOptions);
    }
  };
  function clearWashList() {
    setWashtypeId("");
    setHasUnitOfMeasurement(false);
    setFleetList([]);
    setSelectedOptions([]);
    setWashtypeQuantity("");
  }
  function addNewWashList() {
    return (
      <div>
        <Row className="form-align-center">
          <Form.Group
            as={Col}
            className="mb-3"
            controlId="formPlaintextWashtype"
          >
            <Row>
              <Form.Label column sm="6">
                {t("washtype.label")}
              </Form.Label>
            </Row>
            <Row>
              <Col sm="12">
                <Form.Select
                  className="custom-width"
                  value={
                    washtypeId +
                    "#~#" +
                    washtypeName +
                    "#~#" +
                    unitOfMeasurement
                  }
                  disabled={false}
                  onChange={(e) => {
                    let data = e.target.value.split("#~#");
                    setWashtypeQuantity("");
                    setWashtypeId(data[0]);
                    setWashtypeName(data[1]);
                    setUnitOfMeasurement(data[2]);
                    if (data[2] === "quantity") {
                      setHasUnitOfMeasurement(false);
                    } else {
                      setHasUnitOfMeasurement(true);
                    }
                  }}
                >
                  <option value="">Select</option>
                  {filterdWashList.map((obj) => {
                    return (
                      <option
                        key={obj.id}
                        value={
                          obj.id +
                          "#~#" +
                          obj.name +
                          "#~#" +
                          obj.unitOfMeasurement
                        }
                      >
                        {obj.name}
                      </option>
                    );
                  })}
                </Form.Select>
              </Col>
            </Row>
          </Form.Group>
        </Row>

        <Row
          className="form-align-center"
          style={{ display: hasUnitOfMeasurement ? "block" : "none" }}
        >
          <Form.Group
            as={Col}
            className="mb-3"
            controlId="formPlaintextWashtypeQuantity"
          >
            <Row>
              <Form.Label column sm="6">
                {t("washtypeQuantity.label")}
              </Form.Label>
            </Row>
            <Row>
              <Col sm="12">
                <FormControl
                  className="input_item"
                  aria-label="Default"
                  aria-describedby="inputGroup-sizing-default"
                  value={washtypeQuantity}
                  onChange={(e) => setWashtypeQuantity(e.target.value)}
                />
              </Col>
            </Row>
          </Form.Group>
        </Row>

        <Row
          className="form-align-center"
          style={{ display: hasUnitOfMeasurement ? "none" : "block" }}
        >
          <Form.Group
            as={Col}
            className="mb-3"
            controlId="formPlaintextVehicleNumber"
          >
            <Row>
              <Form.Label column sm="4">
                {t("vehicleNumber.label")}
              </Form.Label>
            </Row>
            <Row>
              <Col sm="12">
                <CreatableSelect
                  isMulti
                  onChange={handleSelectChange}
                  options={fleetList}
                  value={selectedOptions}
                />
              </Col>
            </Row>
          </Form.Group>
        </Row>
      </div>
    );
  }

  return (
    <Col className="form-container">
      <Row className="head-label">
        <Col xs={8} style={{ padding: "unset" }}>
          {t("washInventory.label")}
        </Col>
        <Col className="menu-position-right item-padding" xs={4}>
          <img
            src={menuLookup}
            alt={"menu-icon"}
            style={{ padding: "10px 0px" }}
            onClick={(e) => {
              navigate("/track");
            }}
          />
        </Col>
      </Row>

      <Row className="form-align-center">
        <Form.Group as={Col} className="mb-3" controlId="formPlaintextAccount">
          <Row>
            <Form.Label column sm="6">
              {t("account.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Select
                options={accountOptions}
                value={selectedAccountOption}
                onChange={(e) => {
                  setSelectedAccountOption(e);
                  let data = e.value.split("#~#");
                  setSelectedAccountWashTypeIds(e.washtypeIds);
                  setAccountId(data[0]);
                  setAccountName(data[1]);
                  setAccountLocationNumber(data[2]);
                }}
              />
            </Col>
          </Row>
        </Form.Group>
      </Row>
      <Row className="form-align-center">
        <Form.Group
          as={Col}
          className="mb-3"
          controlId="formPlaintexPreSelectedFleets"
        >
          <Row>
            <Col sm="12">
              <PreSelectedFleets
                preSelectedFleetNumberList={preSelectedFleetNumberList}
              />
            </Col>
          </Row>
        </Form.Group>
      </Row>
      {preSelectedFleetNumberList.length > 0 ? (
        <Row>
          <Row className="form-align-center" style={{ margin: "auto" }}>
            <Button
              className="login-btn"
              onClick={handleShowModal}
              style={{ display: accountId ? "block" : "none" }}
            >
              {t("addNewButton.label")}
            </Button>
          </Row>
          <Modal show={showAddFleetsModal} onHide={handleCloseModal}>
            <Modal.Header>
              <Modal.Title>{t("addNewFleets.label")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{addNewWashList()}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                {t("close.label")}
              </Button>
              <Button
                variant="primary"
                disabled={
                  (washtypeId && selectedOptions.length > 0) || washtypeQuantity
                    ? false
                    : true
                }
                onClick={(e) => {
                  if (
                    (washtypeId && selectedOptions.length > 0) ||
                    washtypeQuantity
                  ) {
                    UpdateFleetInfo();
                  }
                }}
              >
                {t("add.label")}
              </Button>
            </Modal.Footer>
          </Modal>
        </Row>
      ) : (
        <Row>{addNewWashList()}</Row>
      )}

      <Row className="form-align-center" style={{ padding: "1px 10px" }}>
        <Button
          className="login-btn"
          style={{ margin: "auto" }}
          disabled={
            !(
              (accountId &&
                washtypeId &&
                (hasUnitOfMeasurement
                  ? washtypeQuantity
                  : selectedOptions.length > 0)) ||
              preSelectedFleetNumberList.length > 0
            )
          }
          onClick={async (e) => {
            if (preSelectedFleetNumberList.length > 0) {
              const sortedWashList = await getSortedWashlistByWashtype();
              if (sortedWashList.length > 0) {
                props.onBulkSave(sortedWashList);
                preSelectedFleetNumberList.forEach((fleet) => {
                  fleet.isSelected = false;
                });
              } else {
                props.setToastMessage(
                  "Please select at least one fleet before proceeding.",
                );
              }
            } else {
              e.preventDefault();
              props.onSave(getWashInventoryData());
              setAccountId(accountId);
            }
            clearWashList();
          }}
        >
          <label className="login-btn-label">{t("save.label")}</label>
        </Button>
      </Row>
      <Row
        className="form-align-center"
        style={{ display: specialInstructions.length > 0 ? "block" : "none" }}
      >
        <Col className="special-instructions" style={{ marginTop: "30px" }}>
          <Row>
            <Table className="table" style={{ padding: "10px 15px" }}>
              <thead>
                <tr className="table-heading">
                  <th>
                    {" "}
                    <img
                      src={infoLogo}
                      alt={"info-icon"}
                      style={{ width: "25px", height: "25px" }}
                    />{" "}
                    Instructions{" "}
                  </th>
                </tr>
              </thead>
              <tbody style={{ border: "white" }}>
                {specialInstructions.map((obj, index) => {
                  return (
                    <tr key={index}>
                      <td>{obj.instructions}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Row>
        </Col>
      </Row>
      <CustomModal
        heading={"Clear Fleets"}
        message={
          "This action will remove all the fleets from the list. Do you need to continue?"
        }
        buttonText={"Clear"}
        showModal={showModal}
        handleClose={handleClose}
        handleSubmitButton={handleClear}
      />
      <CustomModal
        heading={"Instructions"}
        message={instruction}
        buttonText={"Acknowledge"}
        showModal={showAcknowledgementModal}
        handleClose={handleCloseInstructionModal}
        handleSubmitButton={handleAcknowledge}
      />
      <div style={{ marginBottom: "20%" }}></div>
    </Col>
  );
}

export default WashInventory;
